/* Bandeja Club — theme scripts */
(function () {
  'use strict';

  /* ---------------------------------------------------------------- Drawers */

  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var focusable = drawer.querySelector('[data-drawer-close]');
    if (focusable) focusable.focus();
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }

    var closer = event.target.closest('[data-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('.drawer'));
      return;
    }

    if (event.target.classList.contains('drawer__overlay')) {
      closeDrawer(event.target.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.drawer.is-open').forEach(closeDrawer);
  });

  /* ------------------------------------------------------- Quantity inputs */

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-quantity-change]');
    if (!button) return;
    event.preventDefault();

    var wrapper = button.closest('.quantity');
    var input = wrapper.querySelector('input');
    var step = parseInt(button.getAttribute('data-quantity-change'), 10);
    var min = parseInt(input.getAttribute('min') || '0', 10);
    var next = (parseInt(input.value, 10) || 0) + step;
    if (next < min) next = min;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* -------------------------------------------------------- Variant picker */

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    if (!format) return value;
    return format.replace(/\{\{\s*amount\s*\}\}/, value);
  }

  function VariantPicker(root) {
    this.root = root;
    this.productId = root.getAttribute('data-product-id');
    this.sectionId = root.getAttribute('data-section-id');

    var dataEl = document.getElementById('VariantData-' + this.sectionId);
    if (!dataEl) return;

    try {
      this.variants = JSON.parse(dataEl.textContent);
    } catch (error) {
      this.variants = [];
    }

    this.moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
    this.root.addEventListener('change', this.onChange.bind(this));
    this.update();
  }

  VariantPicker.prototype.selectedOptions = function () {
    return Array.prototype.map.call(
      this.root.querySelectorAll('[data-option-index]'),
      function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        var select = fieldset.querySelector('select');
        if (checked) return checked.value;
        if (select) return select.value;
        return null;
      }
    );
  };

  VariantPicker.prototype.matchVariant = function (options) {
    return this.variants.find(function (variant) {
      return options.every(function (value, index) {
        return variant.options[index] === value;
      });
    });
  };

  VariantPicker.prototype.onChange = function () {
    this.update();
  };

  VariantPicker.prototype.update = function () {
    var options = this.selectedOptions();
    var variant = this.matchVariant(options);
    var scope = document.getElementById('ProductInfo-' + this.sectionId) || document;

    // Selected option labels
    this.root.querySelectorAll('[data-selected-value]').forEach(function (el, index) {
      if (options[index]) el.textContent = options[index];
    });

    var idInput = scope.querySelector('[data-variant-id]');
    var button = scope.querySelector('[data-add-button]');
    var buttonText = button ? button.querySelector('[data-add-button-text]') : null;
    var priceEl = scope.querySelector('[data-price-wrapper]');

    if (!variant) {
      if (button) {
        button.setAttribute('disabled', 'disabled');
        if (buttonText) buttonText.textContent = window.themeStrings.unavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;

    if (button) {
      if (variant.available) {
        button.removeAttribute('disabled');
        if (buttonText) buttonText.textContent = window.themeStrings.addToCart;
      } else {
        button.setAttribute('disabled', 'disabled');
        if (buttonText) buttonText.textContent = window.themeStrings.soldOut;
      }
    }

    if (priceEl) {
      var html = '<span class="price__current">' + formatMoney(variant.price, this.moneyFormat) + '</span>';
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price, this.moneyFormat) + '</s>';
      }
      priceEl.innerHTML = html;
      priceEl.classList.toggle('price--on-sale', !!onSale);
    }

    // Featured media
    if (variant.featured_media_id) {
      var media = document.getElementById('Media-' + this.sectionId + '-' + variant.featured_media_id);
      if (media && media.scrollIntoView) {
        media.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }

    // URL
    if (window.history.replaceState && this.root.getAttribute('data-update-url') !== 'false') {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  document.querySelectorAll('[data-variant-picker]').forEach(function (el) {
    new VariantPicker(el);
  });

  /* ------------------------------------------------------------ Cart count */

  function refreshCartCount() {
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* -------------------------------------------------------- Add to cart AJAX */

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (form.getAttribute('data-ajax') === 'false') return;
      event.preventDefault();

      var button = form.querySelector('[data-add-button]');
      var errorEl = form.querySelector('[data-form-error]');
      if (errorEl) errorEl.hidden = true;
      if (button) button.classList.add('is-disabled');

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (response) { return response.json().then(function (body) { return { ok: response.ok, body: body }; }); })
        .then(function (result) {
          if (!result.ok) {
            if (errorEl) {
              errorEl.textContent = result.body.description || window.themeStrings.cartError;
              errorEl.hidden = false;
            }
            return;
          }
          refreshCartCount();
          var drawer = document.getElementById('CartDrawer');
          if (drawer) {
            reloadCartDrawer(drawer);
          } else {
            window.location.href = window.routes.cart_url;
          }
        })
        .catch(function () {
          if (errorEl) {
            errorEl.textContent = window.themeStrings.cartError;
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          if (button) button.classList.remove('is-disabled');
        });
    });
  });

  function reloadCartDrawer(drawer) {
    fetch(window.routes.cart_url + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var fresh = parsed.querySelector('#CartDrawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        openDrawer(drawer);
      })
      .catch(function () { window.location.href = window.routes.cart_url; });
  }

  /* ------------------------------------------------------- Cart line updates */

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity]');
    if (!input) return;
    updateCartLine(input.getAttribute('data-line'), input.value);
  });

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (!remove) return;
    event.preventDefault();
    updateCartLine(remove.getAttribute('data-line'), 0);
  });

  function updateCartLine(line, quantity) {
    document.body.classList.add('cart-loading');
    fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    })
      .then(function (response) { return response.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  /* --------------------------------------------------- Localization selects */

  document.querySelectorAll('.localization select').forEach(function (select) {
    select.addEventListener('change', function () {
      select.closest('form').submit();
    });
  });

  /* -------------------------------------------------------------- Marquee */

  document.querySelectorAll('[data-marquee]').forEach(function (track) {
    track.innerHTML += track.innerHTML;
  });
})();
